import request from '@/utils/request';

/**模拟登录 */
export function simulateLogin (data) {
    return request({
        url: '/system/operrecord/simulateLogin',
        method: 'post',
        data
    })
}

//敏感信息埋点
export function operrecordAceInfo ({ type, id, field, fun }) {
    return request({
        url: `/system/operrecord/aceInfo/${type}/${id}/${field}/${fun}`,
        method: "get",
        headers: { repeatSubmit: false }
    })
}


//敏感信息操作记录
export function getOperRecordList (data, page) {
    return request({
        url: '/system/operrecord/aceInfo/list/page',
        method: 'post',
        headers: { repeatSubmit: false },
        params: page,
        data
    })
}